import React, { FC, useContext } from 'react';

import { AlertIcon, Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './AutomaticPerminuteTariff.module.scss';

export const AutomaticPerminuteTariff: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('ai_tariffs');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <div className={s.autoProlongation}>
        <Toggle
          onChange={(value: string) =>
            setSetting({
              alias: ESettingsAliases.SHELL_PER_MINUTE_ON_SESSION_END,
              value: value ? '1' : '0',
            })
          }
          value={settings.runPerMinuteOnSessionEnd}
          label={t('setting.sessionProlongation')}
          description={t('settings.billing.tariffs.automatic.description')}
          variant="secondary"
          emptyBg
          disabled={!isAvailable}
          rightContent={!isAvailable ? <SettingsLock /> : undefined}
        />
        <div className={s.helper}>
          <AlertIcon size="s" />
          {t('setting.sessionProlongation.help')}
        </div>
      </div>
    </>
  );
};
